import React, {Component} from 'react';
import './PCBService.css';
import '../../../Common/Common.css';
import LatestOrders from './LatestOrders/LatestOrders';
import ServiceCard from "./ServiceCard/ServiceCard";
import {FormattedMessage} from "react-intl";
import InitialQuotationState from "../../QuotationForm/InitialQuotationState";
import {Link} from 'react-router-dom';
import homePgNewBlock from '../../../../assets/img/Banner_6.png';
import homePgNewBlock2 from '../../../../assets/img/home_pg_new_block.png';

class PCBService extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quotation: {...InitialQuotationState.quotation},
            serviceParam1: {...InitialQuotationState.serviceParam},
            serviceParam2: {...InitialQuotationState.serviceParam},
            serviceParam3: {...InitialQuotationState.serviceParam},
            serviceCardQuotation1: {...InitialQuotationState.serviceCardQuotation1},
            serviceCardQuotation2: {...InitialQuotationState.serviceCardQuotation2},
            serviceCardQuotation3: {...InitialQuotationState.serviceCardQuotation3}

        };
        this.generateServiceQuotations = this.generateServiceQuotations.bind(this);
        this.setServiceValues = this.setServiceValues.bind(this);
    }

    setServiceValues = (serviceQuotation, buildTime) => {
        let colorValue = serviceQuotation.pcbParam.pcbColor;
        let surfaceValue = serviceQuotation.pcbParam.surfaceFinish;
        let layerValue = serviceQuotation.pcbParam.layer;
        let qtyValue = serviceQuotation.pcbParam.qty;
        let thicknessValue = "t " + serviceQuotation.pcbParam.thickness;
        let buildTimeValue = buildTime;

        let dimensions = serviceQuotation.pcbParam.width !== '' && serviceQuotation.pcbParam.length !== '' ?
            serviceQuotation.pcbParam.width + "mm*" + serviceQuotation.pcbParam.length + "mm" : '';

        let color = colorValue === 1 ? <FormattedMessage id="app.home-content.pcb-service.service-green"
                                                         defaultMessage="Green"
                                                         description=""/> :
            colorValue === 2 ? <FormattedMessage id="app.home-content.pcb-service.service-red"
                                                 defaultMessage="Red"
                                                 description=""/> :
                colorValue === 3 ? <FormattedMessage id="app.home-content.pcb-service.service-yellow"
                                                     defaultMessage="Yellow"
                                                     description=""/> :
                    colorValue === 4 ? <FormattedMessage id="app.home-content.pcb-service.service-blue"
                                                         defaultMessage="Blue"
                                                         description=""/> :
                        colorValue === 5 ? <FormattedMessage id="app.home-content.pcb-service.service-white"
                                                             defaultMessage="White"
                                                             description=""/> :
                            colorValue === 6 ? <FormattedMessage id="app.home-content.pcb-service.service-black"
                                                                 defaultMessage="Black"
                                                                 description=""/> : '';

        let surface = surfaceValue === 1 ? <FormattedMessage id="app.pcb-quotation.pcb-surface-finish-1"
                                                             defaultMessage="HASL(with lead)"
                                                             description=""/> :
            surfaceValue === 2 ? <FormattedMessage id="app.pcb-quotation.pcb-surface-finish-2"
                                                   defaultMessage="LeadFree HASL+RoHS"
                                                   description=""/> :
                surfaceValue === 3 ? <FormattedMessage id="app.pcb-quotation.pcb-surface-finish-3"
                                                       defaultMessage="ENIG-RoHS"
                                                       description=""/> : '';
        let serviceParam = {...InitialQuotationState.serviceParam};

        serviceParam.layer = layerValue;
        serviceParam.dimensions = dimensions;
        serviceParam.sheets = qtyValue;
        serviceParam.thickness = thicknessValue;
        serviceParam.color = color;
        serviceParam.surface = surface;
        serviceParam.buildTime = buildTimeValue;

        return serviceParam;
    };
    generateServiceQuotations = (serviceCard) => {
        let serviceQuotation = {...this.state.quotation};

        if (serviceCard === 1) {

            serviceQuotation.pcbParam.layer = 2;
            serviceQuotation.pcbParam.length = 100;
            serviceQuotation.pcbParam.width = 100;
            serviceQuotation.pcbParam.qty = 10;
            serviceQuotation.pcbParam.thickness = 1.6;
            serviceQuotation.pcbParam.pcbColor = 1;
            serviceQuotation.pcbParam.surfaceFinish = 1;

            let serviceParam = this.setServiceValues(serviceQuotation, "48");

            this.setState({
                serviceParam1: {
                    layer: serviceParam.layer,
                    dimensions: serviceParam.dimensions,
                    sheets: serviceParam.sheets,
                    thickness: serviceParam.thickness,
                    color: serviceParam.color,
                    surface: serviceParam.surface,
                    buildTime: serviceParam.buildTime
                }
            });
        } else if (serviceCard === 2) {
            serviceQuotation.pcbParam.layer = 4;
            serviceQuotation.pcbParam.length = 100;
            serviceQuotation.pcbParam.width = 100;
            serviceQuotation.pcbParam.qty = 10;
            serviceQuotation.pcbParam.thickness = 1.6;
            serviceQuotation.pcbParam.pcbColor = 1;
            serviceQuotation.pcbParam.surfaceFinish = 1;

            let serviceParam = this.setServiceValues(serviceQuotation, "144");

            this.setState({
                serviceParam2: {
                    layer: serviceParam.layer,
                    dimensions: serviceParam.dimensions,
                    sheets: serviceParam.sheets,
                    thickness: serviceParam.thickness,
                    color: serviceParam.color,
                    surface: serviceParam.surface,
                    buildTime: serviceParam.buildTime
                }
            });

        } else {
            serviceQuotation.pcbParam.layer = 6;
            serviceQuotation.pcbParam.length = 100;
            serviceQuotation.pcbParam.width = 100;
            serviceQuotation.pcbParam.qty = 10;
            serviceQuotation.pcbParam.thickness = 1.6;
            serviceQuotation.pcbParam.pcbColor = 1;
            serviceQuotation.pcbParam.surfaceFinish = 1;

            let serviceParam = this.setServiceValues(serviceQuotation, "192");

            this.setState({
                serviceParam3: {
                    layer: serviceParam.layer,
                    dimensions: serviceParam.dimensions,
                    sheets: serviceParam.sheets,
                    thickness: serviceParam.thickness,
                    color: serviceParam.color,
                    surface: serviceParam.surface,
                    buildTime: serviceParam.buildTime
                }
            });
        }

    };

    componentDidMount() {
        this.generateServiceQuotations(1);
        this.generateServiceQuotations(2);
        this.generateServiceQuotations(3);

    }

    render() {

        let serviceCardHeading1 = <FormattedMessage id="app.home-content.pcb-service.service-heading1"
                                                    defaultMessage="1-2 Layer Substrate"
                                                    description=""/>;
        let serviceCardHeading2 = <FormattedMessage id="app.home-content.pcb-service.service-heading2"
                                                    defaultMessage="4 Layer Substrate"
                                                    description=""/>;
        let serviceCardHeading3 = <FormattedMessage id="app.home-content.pcb-service.service-heading3"
                                                    defaultMessage="6 Layer Substrate"
                                                    description=""/>;

        return (
            <div className="">
                {/* <div className="homepage-heading">

                     <FormattedMessage id="app.home-content.pcb-service-heading1"
                                      defaultMessage="KITCUT PCB PCB cost is the lowest in the world. Quote now"
                                      description=""/>
                    <p className="service">​
                        <FormattedMessage id="app.home-content.pcb-service-heading2"
                                          defaultMessage="Service"
                                          description=""/></p>
                </div>*/}
                <div className="row">
                    {/*<div className="pull-left col-md-6">*/}
                    {/*<div className="col-md-6" ></div>*/}


                    {/*/////////////////////////////////////////////////////*/}
                    {/*<div className="col-rating-card">*/}
                    {/*<LatestOrders/>*/}
                    {/*</div>*/}
                    {/*/!*</div>*!/*/}

                    {/*<div className="col-md-6">*/}
                    {/*<div className="col-new-detail-block">*/}
                    {/*<img className="sales-img" src={homePgNewBlock} alt="details"/>*/}
                    {/*</div>*/}

                    {/*/////////////////////////////////////////////////////*/}


                    {/*<div className="col-md-1"></div>*/}

                    {/*<div className="col-md-4 padding-pcb-service-right">
                        <LatestOrders/>
                    </div>*/}


                    <div className="col-md-12 padding-pcb-service-left" id="service-img-id">
                        <img className="sales-img" src={homePgNewBlock} alt="details"/>
                        {/*<img src={homePgNewBlock} alt="details"/>*/}
                    </div>

                    {/*<div className="col-md-1"></div>*/}


                    {/*</div>*/}
                    {/*<div className="pull-right">
                        <Link to={{
                            pathname: '/pcb_quotation/new',
                            quotation: this.state.serviceCardQuotation1,
                            pcbMode : true
                        }}>
                        <div className="col-service-card">
                            <ServiceCard
                                serviceParam = {this.state.serviceParam1}
                                serviceCardHeading = {serviceCardHeading1}
                                serviceCard = {1}
                                total = {"3,418"}
                                costPerItem = {"341"}
                            />
                        </div>
                        </Link>
                        <Link to={{
                            pathname: '/pcb_quotation/new',
                            quotation: this.state.serviceCardQuotation2,
                            pcbMode : true
                        }}>
                        <div className="col-service-card">
                            <ServiceCard
                                serviceParam = {this.state.serviceParam2}
                                serviceCardHeading = {serviceCardHeading2}
                                serviceCard = {2}
                                total = {"6,036"}
                                costPerItem = {"603"}
                            />
                        </div>
                        </Link>
                            <Link to={{
                                pathname: '/pcb_quotation/new',
                                quotation: this.state.serviceCardQuotation3,
                                pcbMode : true
                            }}>
                        <div className="col-service-card">
                            <ServiceCard
                                serviceParam = {this.state.serviceParam3}
                                serviceCardHeading = {serviceCardHeading3}
                                serviceCard = {3}
                                total = {"12,416"}
                                costPerItem = {"1241"}
                            />
                        </div>
                            </Link>
                    </div>*/}
                </div>
            </div>
        );
    }

}

export default PCBService;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/PCBService/PCBService.js